import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';

export const MAX_ATTACHMENT_SIZE_BYTES = 5 * 1024 * 1024; // 5MB
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png'];

export interface UploadAttachmentResponse {
  attachmentId: number;
  url: string;
}

@Injectable({ providedIn: 'root' })
export class AttachmentsService {
  private readonly baseUrl = `${environment.backend.url}/api/attachments/v1`;

  constructor(private readonly http: HttpClient) {}

  /**
   * Uploads a file. File must be JPG or PNG, max 5MB.
   * @param file - The file to upload
   * @param fileName - Optional filename for storage
   * @returns Observable with attachmentId and url
   */
  upload(file: File, fileName?: string): Observable<UploadAttachmentResponse> {
    if (file.size > MAX_ATTACHMENT_SIZE_BYTES) {
      return throwError(() => new Error('O arquivo excede o limite de 5MB.'));
    }
    if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
      return throwError(() => new Error('Aceito apenas JPG ou PNG.'));
    }

    const formData = new FormData();
    formData.append('File', file);
    if (fileName != null && fileName !== '') {
      formData.append('FileName', fileName);
    }

    return this.http.post<UploadAttachmentResponse>(`${this.baseUrl}/upload`, formData);
  }
}
